const getValueByPropOrFallback = (targetObject: Record<string, any>, prop: string, fallbackValue: any) => targetObject[prop] ?? fallbackValue;

export default getValueByPropOrFallback;
